'use strict'

const {
  isFieldFromReferencedCollection,
  getReferenceFieldName,
  getFieldFromReferencedCollectionName
} = require('dbsm-common/src/reference-fields/fieldPath')
const get_ = require('lodash/get')

module.exports = (schema, relatedSchemas) => fieldName => {
  if (isFieldFromReferencedCollection(fieldName)) {
    const referenceFieldName = getReferenceFieldName(fieldName)
    const fieldFromReferencedCollectionName = getFieldFromReferencedCollectionName(
      fieldName
    )
    const referencedCollection =
      schema.fields[referenceFieldName].referencedCollection
    return get_(relatedSchemas[referencedCollection].fields, [
      fieldFromReferencedCollectionName,
      'type'
    ])
  }
  return get_(schema, ['fields', fieldName, 'type'])
}



// WEBPACK FOOTER //
// ./helpers/getFieldType.js